import { cn } from "utils/cn";

export const BotResponse: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"div">
> = (props) => (
  <div
    {...props}
    className={cn(
      "whitespace-pre-line break-words pr-5",
      "[&>span:last-of-type]:animate-fadeIn [&>span:last-of-type]:duration-500",
      "empty:after:block empty:after:opacity-50 empty:after:content-['Awaiting_response...']",
      "[&_ol]:block [&_ol]:list-decimal [&_ol]:whitespace-normal [&_ol]:ps-10",
      "[&_ul]:block [&_ul]:list-disc [&_ul]:whitespace-normal [&_ul]:ps-10",
      "[&_li:last-of-type]:mb-0 [&_li]:mb-4",
      "[&_pre]:m-0 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:p-2",
      "[&_code]:rounded",
      "[&_pre_code.hljs]:block [&_pre_code.hljs]:overflow-x-auto [&_pre_code.hljs]:p-4",
      "[&_code.hljs]:px-[5px] [&_code.hljs]:py-[3px] [&_code]:px-[5px] [&_code]:py-[3px]",
      "[&_.hljs]:bg-[#2b2b2b] [&_code]:bg-[#2b2b2b] [&_pre]:bg-[#2b2b2b]",
      "[&_.hljs]:text-[#f8f8f2] [&_code]:text-[#f8f8f2] [&_pre]:text-[#f8f8f2]",
      "[&_.hljs-comment]:text-[#d4d0ab] [&_.hljs-quote]:text-[#d4d0ab]",
      "[&_.hljs-deletion]:text-[#ffa07a] [&_.hljs-name]:text-[#ffa07a] [&_.hljs-regexp]:text-[#ffa07a] [&_.hljs-selector-class]:text-[#ffa07a] [&_.hljs-selector-id]:text-[#ffa07a] [&_.hljs-tag]:text-[#ffa07a] [&_.hljs-template-variable]:text-[#ffa07a] [&_.hljs-variable]:text-[#ffa07a]",
      "[&_.hljs-built_in]:text-[#f5ab35] [&_.hljs-link]:text-[#f5ab35] [&_.hljs-literal]:text-[#f5ab35] [&_.hljs-meta]:text-[#f5ab35] [&_.hljs-number]:text-[#f5ab35] [&_.hljs-params]:text-[#f5ab35] [&_.hljs-type]:text-[#f5ab35]",
      "[&_.hljs-attribute]:text-[gold]",
      "[&_.hljs-addition]:text-[#abe338] [&_.hljs-bullet]:text-[#abe338] [&_.hljs-string]:text-[#abe338] [&_.hljs-symbol]:text-[#abe338]",
      "[&_.hljs-section]:text-[#00e0e0] [&_.hljs-title]:text-[#00e0e0]",
      "[&_.hljs-keyword]:text-[#dcc6e0] [&_.hljs-selector-tag]:text-[#dcc6e0]",
      "[&_.hljs-emphasis]:italic",
      "[&_.hljs-strong]:font-bold",
      "contrast-more:[&_.hljs-addition]:text-[highlight] contrast-more:[&_.hljs-attribute]:text-[highlight] contrast-more:[&_.hljs-build_in]:text-[highlight] contrast-more:[&_.hljs-bullet]:text-[highlight] contrast-more:[&_.hljs-comment]:text-[highlight] contrast-more:[&_.hljs-keyword]:font-bold contrast-more:[&_.hljs-link]:text-[highlight] contrast-more:[&_.hljs-literal]:text-[highlight] contrast-more:[&_.hljs-meta]:text-[highlight] contrast-more:[&_.hljs-number]:text-[highlight] contrast-more:[&_.hljs-params]:text-[highlight] contrast-more:[&_.hljs-quote]:text-[highlight] contrast-more:[&_.hljs-selector-tag]:font-bold contrast-more:[&_.hljs-string]:text-[highlight] contrast-more:[&_.hljs-symbol]:text-[highlight] contrast-more:[&_.hljs-type]:text-[highlight]",
      props.className
    )}
  />
);
